import { Component, input, model, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { isSameDay, addDays, addMonths, differenceInCalendarDays, startOfDay, isLastDayOfMonth, isFirstDayOfMonth, endOfMonth } from 'date-fns';
import { ModalDatePicker } from '../modal-date-picker/modal-date-picker';
import { DatePickerSelection } from '../modal-date-picker/date-picker.interfaces';
import { ButtonComponent } from '../ui/button/button';

@Component({
  selector: 'lib-selector-date-picker',
  standalone: true,
  imports: [CommonModule, ModalDatePicker, ButtonComponent],
  templateUrl: './selector-date-picker.html',
})
export class SelectorDatePicker {

  maxDays = input<number>(92);
  isOpen = model<boolean>(false);
  dateSelection = model<DatePickerSelection>({
    startDate: new Date(),
    endDate: new Date(),
    type: 'none'
  });
  confirmed = output<DatePickerSelection>();
  closed = output<void>();

  isDatePickerOpen = signal(false);

  openDatePicker() {
    this.isDatePickerOpen.set(true);
  }

  isSameDay(dateA: Date | null, dateB: Date | null) {
    if(dateA == null || dateB == null) return false;
    return isSameDay(dateA, dateB);
  }

  isToday(d: Date | null) {
    if (!d) return false;
    return isSameDay(d, new Date());
  }


  moveRange(forward: boolean) {
    const sel = this.dateSelection();
    if (!sel?.startDate || !sel?.endDate) return;

    const start = startOfDay(sel.startDate);
    const end = startOfDay(sel.endDate);

    let newStart: Date;
    let newEnd: Date;
    const direction = forward? 1 : -1;

    // si esta sel·leccionat el mes sencer, desplaçar mes a mes a al canviar les dates amb les fletxetes
    if(isFirstDayOfMonth(start) && isLastDayOfMonth(end)) {
      newStart = addMonths(start, direction);
      newEnd = startOfDay(endOfMonth(addMonths(start, direction)));
    } else {
      // Longitud inclusiva: 10..12 => 3 dies
      const days = differenceInCalendarDays(end, start) + 1;

      newStart = addDays(start, direction * days);
      newEnd = addDays(end, direction * days);
    }


    this.dateSelection.update(s => ({
      ...s,
      startDate: newStart,
      endDate: newEnd,
      type: 'custom'
    }));
  }

  onConfirmed(selection: DatePickerSelection) {
    this.dateSelection.set(selection);
    this.confirmed.emit(selection);
    this.isDatePickerOpen.set(false);
  }

  onClosed() {
    this.closed.emit();
    this.isDatePickerOpen.set(false);
  }
}
